<template>
  <div class="ObjPopup_Body">
    <template v-if="ObjPopupData.type.indexOf('RFQ') != -1">
      <div
        class="CurrentBox"
        :class="{ ISpadding: isSend }"
        @click="getRFQDetails"
      >
        <span class="infoText" v-if="isSend">{{
          $t("slack.CurrentRFQtext")
        }}</span>
        <div class="container flex">
          <div
            class="flex aic jc-c"
            style="
              height: 34px;
              width: 34px;
              background-color: #f59a23;
              border-radius: 4px;
              margin: 15px 0;
            "
          >
            <i class="iconfont icon-a-RFQ_huaban1 f22 fff"></i>
          </div>
          <div class="content">
            <p class="title">
              <span v-for="(item, index) in RFQData.data.modelData" :key="index"
                >{{ item.model }} * {{ item.Qty }}</span
              >
            </p>

            <p
              class="info flex aic fww"
              v-if="RFQData.data.slackType == 'ContactsRFQ'"
            >
              <template v-if="userInfo.type != 4">
                <template v-if="lang == 'zh-cn'">
                  <span>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      RFQData.data.PurchaseQTNcount
                    }})
                  </span>
                  <span style="margin: 0 5px">|</span>
                  {{ $t("slack.RelatedContactQTN") }} ({{
                    RFQData.data.ContactQTNcount
                  }})
                </template>
                <template v-else>
                  <span style="margin-bottom: 4px">
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      RFQData.data.PurchaseQTNcount
                    }})
                  </span>
                  {{ $t("slack.RelatedContactQTN") }} ({{
                    RFQData.data.ContactQTNcount
                  }})
                </template>
              </template>
              <template v-else>
                <span>
                  {{ $t("slack.RelatedQTN") }} ({{
                    Number(RFQData.data.ContactQTNcount) +
                      Number(RFQData.data.PurchaseQTNcount) >=
                    10
                      ? Number(RFQData.data.ContactQTNcount) +
                        Number(RFQData.data.PurchaseQTNcount)
                      : "0" +
                        (Number(RFQData.data.ContactQTNcount) +
                          Number(RFQData.data.PurchaseQTNcount))
                  }})
                </span>
              </template>
            </p>
            <p
              class="info flex aic"
              v-else-if="RFQData.data.slackType == 'MyRFQ'"
            >
              <span>
                {{ $t("slack.RelatedQTN") }} ({{
                  RFQData.data.ContactQTNcount
                }})
              </span>
            </p>
            <p class="info flex aic fww" v-else>
              <template v-if="userInfo.type != 4">
                <template v-if="lang == 'zh-cn'">
                  <span>
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      RFQData.data.PurchaseQTNcount
                    }})
                  </span>
                  <span style="margin: 0 5px">|</span>
                  {{ $t("slack.RelatedContactQTN") }} ({{
                    RFQData.data.ContactQTNcount
                  }})
                </template>
                <template v-else>
                  <span style="margin-bottom: 4px">
                    {{ $t("slack.RelatedPurchaseQTN") }} ({{
                      RFQData.data.PurchaseQTNcount
                    }})
                  </span>
                  {{ $t("slack.RelatedContactQTN") }} ({{
                    RFQData.data.ContactQTNcount
                  }})
                </template>
              </template>
              <template v-else>
                <span
                  v-if="
                    RFQData.data.inquiryInfo.ownerId == userInfo.user_uid ||
                    RFQData.data.inquiryInfo.create_user == userInfo.user_uid
                  "
                >
                  {{ $t("slack.RelatedQTN") }} ({{
                    Number(RFQData.data.ContactQTNcount) +
                      Number(RFQData.data.PurchaseQTNcount) >=
                    10
                      ? Number(RFQData.data.ContactQTNcount) +
                        Number(RFQData.data.PurchaseQTNcount)
                      : "0" +
                        (Number(RFQData.data.ContactQTNcount) +
                          Number(RFQData.data.PurchaseQTNcount))
                  }})
                </span>
                <span v-else>
                  {{ $t("slack.RelatedQTN") }} ({{
                    RFQData.data.ContactQTNcount
                  }})
                </span>
              </template>
            </p>
            <p class="info" v-if="RFQData.data.inquiryInfo">
              {{ getupdate_time(RFQData.data.inquiryInfo.update_time) }}
            </p>
          </div>
          <div class="sendWrap" @click.stop="sendClick" v-if="isSend">
            <button>
              <svg
                t="1680753032116"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2780"
                width="20"
                height="22"
              >
                <path
                  d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                  fill="#fff"
                  p-id="2781"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="ObjPopupData.type.indexOf('QTN') != -1">
      <template v-if="ObjPopupData.data.slackType != 'PurchaseQTN'">
        <div
          class="CurrentBox QTNBox"
          :class="{ ISpadding: isSend }"
          @click="getQTNDetails"
        >
          <span class="infoText" v-if="isSend">{{
            $t("slack.CurrentQTNtext")
          }}</span>
          <div class="container flex">
            <div
              class="flex aic jc-c"
              style="
                height: 34px;
                width: 34px;
                background-color: rgb(236, 136, 128);
                border-radius: 4px;
                margin: 15px 0;
              "
            >
              <i class="iconfont icon-a-QTN_huaban1 f22 fff"></i>
            </div>
            <div class="content">
              <div class="title">
                <span v-for="(item, index) in QTNData.modelData" :key="index"
                  >{{ item.model }} * {{ item.Qty }}</span
                >
              </div>
              <p class="info" v-if="QTNData.data.update_time">
                {{ getupdate_time(QTNData.data.update_time) }}
              </p>
            </div>
            <div class="sendWrap" @click.stop="sendClick" v-if="isSend">
              <button>
                <svg
                  t="1680753032116"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2780"
                  width="20"
                  height="22"
                >
                  <path
                    d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                    fill="#fff"
                    p-id="2781"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="CurrentBox QTNBox"
          :class="{ ISpadding: isSend }"
          @click="getQTNDetails"
          v-if="QTNInfo.Type == 1"
        >
          <span class="infoText" v-if="isSend">{{
            $t("slack.CurrentQTNtext")
          }}</span>
          <div class="container flex">
            <div
              class="flex aic jc-c"
              style="
                height: 34px;
                width: 34px;
                background-color: rgb(236, 136, 128);
                border-radius: 4px;
                margin: 15px 0;
              "
            >
              <i class="iconfont icon-a-QTN_huaban1 f22 fff"></i>
            </div>
            <div class="content">
              <div class="title">
                <span v-for="(item, index) in QTNData.modelData" :key="index"
                  >{{ item.model }} * {{ item.Qty }}</span
                >
              </div>
              <p class="info" v-if="QTNData.data.update_time">
                {{ getupdate_time(QTNData.data.update_time) }}
              </p>
            </div>
            <div class="sendWrap" @click.stop="sendClick" v-if="isSend">
              <button>
                <svg
                  t="1680753032116"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2780"
                  width="20"
                  height="22"
                >
                  <path
                    d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                    fill="#fff"
                    p-id="2781"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          class="CurrentBox QTNBox"
          :class="{ ISpadding: isSend }"
          @click="getQTNDetails"
          v-if="QTNInfo.Type == 2"
        >
          <span class="infoText" v-if="isSend">{{
            $t("slack.CurrentQTNtext")
          }}</span>
          <div
            class="container"
            v-if="QTNData.data.item.length > 0 && QTNInfo.activeIndex >= 0"
          >
            <div class="QTNTopInfo" v-if="userInfo.type == 3">
              <p>
                {{
                  QTNData.data.item[QTNInfo.activeIndex].quotation_state_text
                }}
              </p>
            </div>
            <div class="flex">
              <div
                class="flex aic jc-c"
                style="
                  height: 34px;
                  width: 34px;
                  background-color: #f59a23;
                  border-radius: 4px;
                  margin: 15px 0;
                "
              >
                <i class="iconfont icon-a-QTN_huaban1 f22 fff"></i>
              </div>
              <div class="content">
                <p class="title">
                  {{ QTNData.data.item[QTNInfo.activeIndex].model }}
                  *
                  {{ QTNData.data.item[QTNInfo.activeIndex].Qty }}
                </p>
                <div class="info">
                  <p>
                    {{ $t("slack.Brand") }}:
                    {{ QTNData.data.item[QTNInfo.activeIndex].brand_name }}
                  </p>
                  <p>
                    {{ $t("slack.Condition") }}:
                    {{
                      QTNData.data.item[QTNInfo.activeIndex].product_condition
                    }}
                  </p>
                  <p>
                    {{ $t("slack.Leading") }}:
                    {{
                      QTNData.data.item[QTNInfo.activeIndex].product_condition
                    }}
                  </p>
                  <p style="color: #e96c45" v-if="userInfo.type == 3">
                    {{ $t("slack.Cost") }}:
                    <i
                      v-show="
                        QTNData.data.item[QTNInfo.activeIndex].purchase_price
                      "
                      :class="[
                        getCurrencyIcon(
                          QTNData.data.item[QTNInfo.activeIndex]
                            .quotation_current
                        ),
                        'iconfont f14',
                      ]"
                    ></i>
                    <span>
                      {{
                        QTNData.data.item[QTNInfo.activeIndex].purchase_price
                      }}
                    </span>
                  </p>
                  <p style="color: #e96c45" v-if="userInfo.type != 3">
                    {{ $t("slack.Price") }}:
                    <i
                      v-show="
                        QTNData.data.item[QTNInfo.activeIndex].quotation_price
                      "
                      :class="[
                        getCurrencyIcon(
                          QTNData.data.item[QTNInfo.activeIndex]
                            .quotation_price_current
                        ),
                        'iconfont f14',
                      ]"
                    ></i>
                    <span>
                      {{
                        QTNData.data.item[QTNInfo.activeIndex].quotation_price
                      }}
                    </span>
                  </p>
                  <p style="color: #555555" v-if="userInfo.type == 3">
                    {{ $t("slack.Quotedby") }}:
                    {{ QTNData.data.item[QTNInfo.activeIndex].purchaser_name }}
                  </p>
                </div>
              </div>
              <div class="sendWrap" v-if="isSend" @click.stop="sendClick">
                <button>
                  <svg
                    t="1680753032116"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2780"
                    width="20"
                    height="22"
                  >
                    <path
                      d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                      fill="#fff"
                      p-id="2781"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="CurrentBox QTNBox"
          :class="{ ISpadding: isSend }"
          @click="getQTNDetails"
          v-if="QTNInfo.Type == 3"
        >
          <div class="container flex">
            <div
              class="flex aic jc-c"
              style="
                height: 34px;
                width: 34px;
                background-color: rgb(236, 136, 128);
                border-radius: 4px;
                margin: 15px 0;
              "
            >
              <i class="iconfont icon-a-QTN_huaban1 f22 fff"></i>
            </div>
            <div class="content">
              <p class="title">
                <!-- <span
                v-for="(item, index) in QTNData.data.item"
                :key="index"
                >{{ item.model }} * {{ item.Qty }}</span>-->
                <span v-for="(item, index) in QTNData.modelData" :key="index"
                  >{{ item.model }} * {{ item.Qty }}</span
                >
              </p>
              <p class="info" v-if="QTNData.data.update_time">
                {{ getupdate_time(QTNData.data.update_time) }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="ObjPopupData.type == 'SaleOrder'">
      <div
        class="CurrentBox"
        :class="{ ISpadding: isSend }"
        @click="getSaleOrderDetails"
      >
        <span class="infoText" v-if="isSend">{{
          $t("slack.CurrentSalestext")
        }}</span>
        <div class="container flex">
          <div
            class="flex aic jc-c"
            style="
              height: 34px;
              width: 34px;
              background-color: rgb(234, 134, 188);
              border-radius: 4px;
              margin: 15px 0;
            "
          >
            <i class="iconfont icon-a-SalesOrders2_huaban1 f22 fff"></i>
          </div>
          <div class="content">
            <p class="title">
              <span
                v-for="(item, index) in SaleOrderData.data.list.data"
                :key="index"
                >{{ item.product_name_pi }} * {{ item.quantity }}</span
              >
            </p>
            <p class="info flex aic fww" v-if="userInfo.type != 4">
              <template v-if="lang == 'zh-cn'">
                {{ $t("slack.RelatedPurchaseTasks") }} ({{
                  SaleOrderData.data.PurchaseOrderteskNum
                }})
                <span style="margin: 0 5px">|</span>
                {{ $t("slack.RelatedPurchaseOrders") }} ({{
                  SaleOrderData.data.PurchaseOrderNum
                }})
              </template>
              <template v-else>
                <span style="margin-bottom: 4px">
                  {{ $t("slack.RelatedPurchaseTasks") }} ({{
                    SaleOrderData.data.PurchaseOrderteskNum
                  }})
                </span>
                <span>
                  {{ $t("slack.RelatedPurchaseOrders") }} ({{
                    SaleOrderData.data.PurchaseOrderNum
                  }})
                </span>
              </template>
            </p>
            <p class="info">
              {{ getupdate_time(SaleOrderData.data.customer.CreateTime) }}
            </p>
          </div>
          <div class="sendWrap" v-if="isSend" @click.stop="sendClick">
            <button>
              <svg
                t="1680753032116"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2780"
                width="20"
                height="22"
              >
                <path
                  d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                  fill="#fff"
                  p-id="2781"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="ObjPopupData.type == 'PurchaseOrder'">
      <div
        class="CurrentBox"
        :class="{ ISpadding: isSend }"
        @click="getpurseOrderDetails"
      >
        <span class="infoText" v-if="isSend">{{
          $t("slack.CurrentPurchasetext")
        }}</span>
        <div class="container flex">
          <div
            class="flex aic jc-c"
            style="
              height: 34px;
              width: 34px;
              background-color: #76bd55;
              border-radius: 4px;
              margin: 15px 0;
            "
          >
            <i class="iconfont icon-a-SalesOrders2_huaban1 f22 fff"></i>
          </div>
          <div class="content">
            <p class="title">
              <span
                v-for="(item, index) in purchaseOrderData.data.data"
                :key="index"
                >{{ item.Model }} * {{ item.dty }}</span
              >
            </p>
            <p class="info" v-if="userInfo.type != 4">
              {{ $t("slack.RelatedPurchaseTasks") }} ({{
                purchaseOrderData.data.PurchaseOrderteskNum
              }})
            </p>
            <p class="info">
              {{ getupdate_time(purchaseOrderData.data.create_time) }}
            </p>
          </div>
          <div class="sendWrap" v-if="isSend" @click.stop="sendClick">
            <button>
              <svg
                t="1680753032116"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2780"
                width="20"
                height="22"
              >
                <path
                  d="M0 1024l106.496-474.112 588.8-36.864-588.8-39.936L0 0l1024 512z"
                  fill="#fff"
                  p-id="2781"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { HomeStore } from "../../index";
import { mapState } from "pinia";
import { parseTime, getupdate_time, extend } from "../../utils/index";
import { useDemoStore } from "@/pinia/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
import * as Rfq from "@/api/apiRfq/index.js";
import * as Order from "@/api/apiPayOrder/index";
import * as $axios from "../../api/index";
import { CloseBold } from "@element-plus/icons-vue";
import { Kernaldec } from "@/hooks/useDecrypt.js";
export default {
  props: {
    isSend: {
      type: Boolean,
      default: false,
    },
    ObjPopupData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getupdate_time,
      RFQData: {},
      QTNData: {},
      QTNInfo: {
        Type: 1,
        activeIndex: 0,
      },
      SaleOrderData: {},
      purchaseOrderData: {},
      CloseBold,
      // 币种数据
      currencyList: [
        {
          name: "USD",
          icon: "icon-socialusd",
        },
        {
          name: "EUR",
          icon: "icon-eur",
        },
        {
          name: "CNY",
          icon: "icon-rmb fwb",
        },
        {
          name: "GBP",
          icon: "icon-gbp",
        },
        {
          name: "CAD",
          icon: "icon-a-C_huaban1_huaban1 fwb",
        },
        {
          name: "AUD",
          icon: "icon-a-A_huaban1 fwb",
        },
        {
          name: "HKD",
          icon: "icon-a-hk_huaban1 fwb f18",
        },
      ],
    };
  },
  computed: {
    ...mapState(HomeStore, ["userInfo", "isDetail"]),
    lang() {
      return useDemoStore().lang;
    },
  },
  watch: {
    ObjPopupData: {
      handler: function (val) {
        if (val.type.indexOf("RFQ") != -1) {
          this.RFQData = extend(val, true);
        } else if (val.type.indexOf("QTN") != -1) {
          this.QTNData = extend(val, true);
          if (!("modelData" in this.QTNData)) {
            if (this.QTNData.data.modelData) {
              this.QTNData.modelData = this.QTNData.data.modelData;
            } else {
              let modelData = [];
              this.QTNData.data.item.map((item) => {
                if (item.product) {
                  modelData.push({
                    Qty: item.Qty,
                    model: item.product.model,
                  });
                } else {
                  modelData.push({
                    Qty: item.Qty,
                    model: "",
                  });
                }
              });
              this.QTNData.modelData = modelData;
            }
          }
          if (this.QTNData.data.qtn_createid == this.userInfo.user_uid) {
            this.QTNInfo.Type = 1;
          } else {
            this.QTNData.data.item.map((item) => {
              item.model = item.product.model;
              item.brand_name = item.brand.brand_name;
              item.children.map((children) => {
                children.product = item.product;
                children.brand = item.brand;
                children.model = item.product.model;
                children.Qty = item.Qty;
                children.brand_name = item.brand.brand_name;
                val.data.item.push(children);
              });
            });
            let index = val.data.item.findIndex((item) => {
              return item.purchaser_uid == this.userInfo.user_uid;
            });

            if (index >= 0) {
              this.QTNInfo.Type = 2;
              this.QTNInfo.activeIndex = index;
            } else {
              this.QTNInfo.Type = 3;
            }
          }
        } else if (val.type == "SaleOrder") {
          this.SaleOrderData = extend(val, true);
        } else if (val.type == "PurchaseOrder") {
          this.purchaseOrderData = extend(val, true);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getCurrencyIcon(e) {
      if (!e) {
        return "icon-rmb fwb";
      } else {
        let icon = this.currencyList.find((item) => item.name == e);
        return icon.icon;
      }
    },
    expand(val) {
      this.$emit("Slackexpand", val);
    },
    sendClick() {
      this.$emit("sendClick");
    },
    //RFQ详情
    getRFQDetails() {
      if (this.showDetails) {
        HomeStore().ObjPopupData.create_time = this.ObjPopupData.create_time;
        HomeStore().ObjPopupData.id = this.ObjPopupData.id;
        HomeStore().ObjPopupData.slackType = this.ObjPopupData.data.slackType;
        HomeStore().showDetail = true;
        HomeStore().isDetail = true;
        HomeStore().detailLoading = true;
        HomeStore().switchPopupData.show = false;
        HomeStore().switchPopupData.data = [];
        Rfq.$getInquiryInfo({
          token: HomeStore().token,
          inquiry_id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
          isPublic: this.ObjPopupData.data.isPublic,
        }).then((inquiry) => {
          if (inquiry.Status == 1) {
            this.catchEvent();
            return;
          }
          if (this.ObjPopupData.data.slackType == "MyRFQ") {
            $axios
              .getMyRfqVendor({
                token: HomeStore().token,
                inquiry_id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
              })
              .then((res) => {
                if (res.Status != 0) {
                  return;
                }
                let RfqVendor = "";
                let Rfqsales = "";
                let RfqVendor1 = "";
                let Rfqsales1 = "";
                let vendorContactList = [];
                let vendorInfo = res.data.vendorInfo;
                vendorInfo.map((item) => {
                  item.vendorContact.map((res) => {
                    vendorContactList.push({
                      RfqVendor: item.vendor,
                      nickname: res.nickname,
                      user_uid: res.user_uid,
                    });
                  });
                });
                vendorContactList.map((item) => {
                  if (item.user_uid == HomeStore().setting.dialogueInfo.id) {
                    RfqVendor = item.RfqVendor;
                    Rfqsales = item.nickname;
                  }
                  if (item.user_uid == this.userInfo.user_uid) {
                    RfqVendor1 = item.RfqVendor;
                    Rfqsales1 = item.nickname;
                  }
                });
                inquiry.data.inquiryInfo.RfqVendor = RfqVendor;
                inquiry.data.inquiryInfo.Rfqsales = Rfqsales;
                inquiry.data.inquiryInfo.RfqVendor1 = RfqVendor1;
                inquiry.data.inquiryInfo.Rfqsales1 = Rfqsales1;
                inquiry.data.inquiryInfo.vendorContactList = vendorContactList;
                Rfq.$Product({
                  token: HomeStore().token,
                  id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                  isPublic: this.ObjPopupData.data.isPublic,
                }).then((res) => {
                  if (res.Status == 0) {
                    if (res.data.length == 0) {
                      this.catchEvent();
                      return;
                    }
                    res.data.inquiryInfo = inquiry.data.inquiryInfo;
                    let List1 = res.data;
                    if (
                      inquiry.data.inquiryInfo.ownerId ==
                        this.userInfo.user_uid ||
                      inquiry.data.inquiryInfo.create_user ==
                        this.userInfo.user_uid ||
                      this.userInfo.type == 1 ||
                      this.userInfo.type == 6
                    ) {
                      Rfq.$orderget_order_purchase({
                        token: HomeStore().token,
                        inquiry_id:
                          this.ObjPopupData.data.inquiryInfo.inquiry_id,
                        isPublic: this.ObjPopupData.data.isPublic,
                      }).then((res) => {
                        res.data.item.map((item, index) => {
                          item.model = item.product.model;
                          item.brand_name = item.brand.brand_name;
                          item.children.map((children) => {
                            children.product = item.product;
                            children.brand = item.brand;
                            children.model = item.product.model;
                            children.Qty = item.Qty;
                            children.brand_name = item.brand.brand_name;
                            res.data.item.push(children);
                          });
                        });
                        let PurchaseQTNcount = res.data.item.length;
                        if (PurchaseQTNcount > 0) {
                          PurchaseQTNcount =
                            PurchaseQTNcount >= 10
                              ? PurchaseQTNcount
                              : "0" + PurchaseQTNcount;
                        }
                        HomeStore().ObjPopupData.PurchaseQTNcount =
                          PurchaseQTNcount;
                        HomeStore().ObjPopupData.PurchaseQTN = res.data;
                        Rfq.$orderget_order_purchase({
                          token: HomeStore().token,
                          inquiry_id:
                            this.ObjPopupData.data.inquiryInfo.inquiry_id,
                          isContact: 1,
                          isPublic: this.ObjPopupData.data.isPublic,
                        }).then((res) => {
                          res.data.item.map((item) => {
                            item.model = item.product.model;
                            item.brand_name = item.brand.brand_name;
                            item.children.map((children) => {
                              children.product = item.product;
                              children.brand = item.brand;
                              children.model = item.product.model;
                              children.Qty = item.Qty;
                              children.brand_name = item.brand.brand_name;
                              res.data.item.push(children);
                            });
                          });
                          let ContactQTNcount = res.data.item.length;
                          if (ContactQTNcount) {
                            ContactQTNcount =
                              ContactQTNcount >= 10
                                ? ContactQTNcount
                                : "0" + ContactQTNcount;
                          }
                          HomeStore().ObjPopupData.RFQdata = List1;
                          HomeStore().ObjPopupData.ContactQTNcount =
                            ContactQTNcount;
                          HomeStore().ObjPopupData.ContactQTN = res.data;
                          HomeStore().ObjPopupData1 = extend(
                            HomeStore().ObjPopupData,
                            true
                          );
                          HomeStore().ObjPopupData.type = "RFQ";
                          HomeStore().detailLoading = false;
                          HomeStore().showDetail = true;
                          HomeStore().isReply = false;
                        });
                      });
                    } else {
                      if (this.userInfo.type == 3) {
                        Rfq.$pollingTeam_product({
                          token: HomeStore().token,
                          id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                          isPublic: this.ObjPopupData.data.isPublic,
                        }).then((q) => {
                          if (List1.data.length == 0) {
                            List1.data.push(...q.data.data);
                          }
                          HomeStore().ObjPopupData.RFQdata = List1;
                          Rfq.$orderget_order_purchase({
                            token: HomeStore().token,
                            inquiry_id:
                              this.ObjPopupData.data.inquiryInfo.inquiry_id,
                            isPublic: this.ObjPopupData.data.isPublic,
                          }).then((res) => {
                            res.data.item.map((item) => {
                              item.model = item.product.model;
                              item.brand_name = item.brand.brand_name;
                              item.children.map((children) => {
                                children.product = item.product;
                                children.brand = item.brand;
                                children.model = item.product.model;
                                children.Qty = item.Qty;
                                children.brand_name = item.brand.brand_name;
                                res.data.item.push(children);
                              });
                            });
                            let List = res.data;
                            Rfq.$orderGet_team_purchase({
                              token: HomeStore().token,
                              inquiry_id:
                                this.ObjPopupData.data.inquiryInfo.inquiry_id,
                              isPublic: this.ObjPopupData.data.isPublic,
                            }).then((res1) => {
                              res1.data.item.map((item) => {
                                item.model = item.product.model;
                                item.brand_name = item.brand.brand_name;
                                item.children.map((children) => {
                                  children.product = item.product;
                                  children.brand = item.brand;
                                  children.model = item.product.model;
                                  children.Qty = item.Qty;
                                  children.brand_name = item.brand.brand_name;
                                  res.data.item.push(children);
                                });
                              });
                              List.item.push(...res1.data.item);
                              let PurchaseQTNcount = List.item.length;
                              if (PurchaseQTNcount > 0) {
                                PurchaseQTNcount =
                                  PurchaseQTNcount >= 10
                                    ? PurchaseQTNcount
                                    : "0" + PurchaseQTNcount;
                              }
                              HomeStore().ObjPopupData.RFQdata = List1;
                              HomeStore().ObjPopupData.PurchaseQTNcount =
                                PurchaseQTNcount;
                              HomeStore().ObjPopupData.PurchaseQTN = List;
                              HomeStore().ObjPopupData1 = extend(
                                HomeStore().ObjPopupData,
                                true
                              );
                              HomeStore().ObjPopupData.type = "RFQ";
                              HomeStore().detailLoading = false;
                              HomeStore().showDetail = true;
                              HomeStore().isReply = false;
                            });
                          });
                        });
                      }
                      if (this.userInfo.type != 3) {
                        HomeStore().ObjPopupData.RFQdata = List1;
                        Rfq.$orderget_order_purchase({
                          token: HomeStore().token,
                          inquiry_id:
                            this.ObjPopupData.data.inquiryInfo.inquiry_id,
                          isPublic: this.ObjPopupData.data.isPublic,
                        }).then((res) => {
                          res.data.item.map((item, index) => {
                            item.model = item.product.model;
                            item.brand_name = item.brand.brand_name;
                            item.children.map((children) => {
                              children.product = item.product;
                              children.brand = item.brand;
                              children.model = item.product.model;
                              children.Qty = item.Qty;
                              children.brand_name = item.brand.brand_name;
                              res.data.item.push(children);
                            });
                          });
                          let PurchaseQTNcount = res.data.item.length;
                          if (PurchaseQTNcount > 0) {
                            PurchaseQTNcount =
                              PurchaseQTNcount >= 10
                                ? PurchaseQTNcount
                                : "0" + PurchaseQTNcount;
                          }
                          HomeStore().ObjPopupData.PurchaseQTNcount =
                            PurchaseQTNcount;
                          HomeStore().ObjPopupData.PurchaseQTN = res.data;
                          Rfq.$orderget_order_purchase({
                            token: HomeStore().token,
                            inquiry_id:
                              this.ObjPopupData.data.inquiryInfo.inquiry_id,
                            isContact: 1,
                            isPublic: this.ObjPopupData.data.isPublic,
                          }).then((res) => {
                            res.data.item.map((item) => {
                              item.model = item.product.model;
                              item.brand_name = item.brand.brand_name;
                              item.children.map((children) => {
                                children.product = item.product;
                                children.brand = item.brand;
                                children.model = item.product.model;
                                children.Qty = item.Qty;
                                children.brand_name = item.brand.brand_name;
                                res.data.item.push(children);
                              });
                            });
                            let ContactQTNcount = res.data.item.length;
                            if (ContactQTNcount) {
                              ContactQTNcount =
                                ContactQTNcount >= 10
                                  ? ContactQTNcount
                                  : "0" + ContactQTNcount;
                            }
                            HomeStore().ObjPopupData.ContactQTNcount =
                              ContactQTNcount;
                            HomeStore().ObjPopupData.ContactQTN = res.data;
                            HomeStore().ObjPopupData1 = extend(
                              HomeStore().ObjPopupData,
                              true
                            );
                            HomeStore().ObjPopupData.type = "RFQ";
                            HomeStore().detailLoading = false;
                            HomeStore().showDetail = true;
                            HomeStore().isReply = false;
                          });
                        });
                      }
                    }
                  } else {
                    this.catchEvent();
                  }
                });
              });
          } else {
            Rfq.$Product({
              token: HomeStore().token,
              id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
              isPublic: this.ObjPopupData.data.isPublic,
            }).then((res) => {
              if (res.Status == 0) {
                if (res.data.length == 0) {
                  this.catchEvent();
                  return;
                }
                res.data.inquiryInfo = inquiry.data.inquiryInfo;
                let List1 = res.data;
                if (
                  inquiry.data.inquiryInfo.ownerId == this.userInfo.user_uid ||
                  inquiry.data.inquiryInfo.create_user ==
                    this.userInfo.user_uid ||
                  this.userInfo.type == 1 ||
                  this.userInfo.type == 6
                ) {
                  HomeStore().ObjPopupData.RFQdata = List1;
                  Rfq.$orderget_order_purchase({
                    token: HomeStore().token,
                    inquiry_id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                    isPublic: this.ObjPopupData.data.isPublic,
                  }).then((res) => {
                    res.data.item.map((item, index) => {
                      item.model = item.product.model;
                      item.brand_name = item.brand.brand_name;
                      item.children.map((children) => {
                        children.product = item.product;
                        children.brand = item.brand;
                        children.model = item.product.model;
                        children.Qty = item.Qty;
                        children.brand_name = item.brand.brand_name;
                        res.data.item.push(children);
                      });
                    });
                    let PurchaseQTNcount = res.data.item.length;
                    if (PurchaseQTNcount > 0) {
                      PurchaseQTNcount =
                        PurchaseQTNcount >= 10
                          ? PurchaseQTNcount
                          : "0" + PurchaseQTNcount;
                    }
                    HomeStore().ObjPopupData.PurchaseQTNcount =
                      PurchaseQTNcount;
                    HomeStore().ObjPopupData.PurchaseQTN = res.data;
                    Rfq.$orderget_order_purchase({
                      token: HomeStore().token,
                      inquiry_id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                      isContact: 1,
                      isPublic: this.ObjPopupData.data.isPublic,
                    }).then((res) => {
                      res.data.item.map((item) => {
                        item.model = item.product.model;
                        item.brand_name = item.brand.brand_name;
                        item.children.map((children) => {
                          children.product = item.product;
                          children.brand = item.brand;
                          children.model = item.product.model;
                          children.Qty = item.Qty;
                          children.brand_name = item.brand.brand_name;
                          res.data.item.push(children);
                        });
                      });
                      let ContactQTNcount = res.data.item.length;
                      if (ContactQTNcount) {
                        ContactQTNcount =
                          ContactQTNcount >= 10
                            ? ContactQTNcount
                            : "0" + ContactQTNcount;
                      }
                      HomeStore().ObjPopupData.ContactQTNcount =
                        ContactQTNcount;
                      HomeStore().ObjPopupData.ContactQTN = res.data;
                      HomeStore().ObjPopupData1 = extend(
                        HomeStore().ObjPopupData,
                        true
                      );
                      HomeStore().ObjPopupData.type = "RFQ";
                      HomeStore().detailLoading = false;
                      HomeStore().showDetail = true;
                      HomeStore().isReply = false;
                    });
                  });
                } else {
                  if (this.userInfo.type == 3) {
                    Rfq.$pollingTeam_product({
                      token: HomeStore().token,
                      id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                      isPublic: this.ObjPopupData.data.isPublic,
                    }).then((q) => {
                      if (List1.data.length == 0) {
                        List1.data.push(...q.data.data);
                      }
                      HomeStore().ObjPopupData.RFQdata = List1;
                      Rfq.$orderget_order_purchase({
                        token: HomeStore().token,
                        inquiry_id:
                          this.ObjPopupData.data.inquiryInfo.inquiry_id,
                        isPublic: this.ObjPopupData.data.isPublic,
                      }).then((res) => {
                        res.data.item.map((item) => {
                          item.model = item.product.model;
                          item.brand_name = item.brand.brand_name;
                          item.children.map((children) => {
                            children.product = item.product;
                            children.brand = item.brand;
                            children.model = item.product.model;
                            children.Qty = item.Qty;
                            children.brand_name = item.brand.brand_name;
                            res.data.item.push(children);
                          });
                        });
                        let List = res.data;
                        Rfq.$orderGet_team_purchase({
                          token: HomeStore().token,
                          inquiry_id:
                            this.ObjPopupData.data.inquiryInfo.inquiry_id,
                          isPublic: this.ObjPopupData.data.isPublic,
                        }).then((res1) => {
                          res1.data.item.map((item) => {
                            item.model = item.product.model;
                            item.brand_name = item.brand.brand_name;
                            item.children.map((children) => {
                              children.product = item.product;
                              children.brand = item.brand;
                              children.model = item.product.model;
                              children.Qty = item.Qty;
                              children.brand_name = item.brand.brand_name;
                              res.data.item.push(children);
                            });
                          });
                          List.item.push(...res1.data.item);
                          let PurchaseQTNcount = List.item.length;
                          if (PurchaseQTNcount > 0) {
                            PurchaseQTNcount =
                              PurchaseQTNcount >= 10
                                ? PurchaseQTNcount
                                : "0" + PurchaseQTNcount;
                          }
                          HomeStore().ObjPopupData.PurchaseQTNcount =
                            PurchaseQTNcount;
                          HomeStore().ObjPopupData.PurchaseQTN = List;
                          HomeStore().ObjPopupData1 = extend(
                            HomeStore().ObjPopupData,
                            true
                          );
                          HomeStore().ObjPopupData.type = "RFQ";
                          HomeStore().detailLoading = false;
                          HomeStore().showDetail = true;
                          HomeStore().isReply = false;
                        });
                      });
                    });
                  }
                  if (this.userInfo.type != 3) {
                    HomeStore().ObjPopupData.RFQdata = List1;
                    Rfq.$orderget_order_purchase({
                      token: HomeStore().token,
                      inquiry_id: this.ObjPopupData.data.inquiryInfo.inquiry_id,
                      isPublic: this.ObjPopupData.data.isPublic,
                    }).then((res) => {
                      res.data.item.map((item, index) => {
                        item.model = item.product.model;
                        item.brand_name = item.brand.brand_name;
                        item.children.map((children) => {
                          children.product = item.product;
                          children.brand = item.brand;
                          children.model = item.product.model;
                          children.Qty = item.Qty;
                          children.brand_name = item.brand.brand_name;
                          res.data.item.push(children);
                        });
                      });
                      let PurchaseQTNcount = res.data.item.length;
                      if (PurchaseQTNcount > 0) {
                        PurchaseQTNcount =
                          PurchaseQTNcount >= 10
                            ? PurchaseQTNcount
                            : "0" + PurchaseQTNcount;
                      }
                      HomeStore().ObjPopupData.PurchaseQTNcount =
                        PurchaseQTNcount;
                      HomeStore().ObjPopupData.PurchaseQTN = res.data;
                      Rfq.$orderget_order_purchase({
                        token: HomeStore().token,
                        inquiry_id:
                          this.ObjPopupData.data.inquiryInfo.inquiry_id,
                        isContact: 1,
                        isPublic: this.ObjPopupData.data.isPublic,
                      }).then((res) => {
                        res.data.item.map((item) => {
                          item.model = item.product.model;
                          item.brand_name = item.brand.brand_name;
                          item.children.map((children) => {
                            children.product = item.product;
                            children.brand = item.brand;
                            children.model = item.product.model;
                            children.Qty = item.Qty;
                            children.brand_name = item.brand.brand_name;
                            res.data.item.push(children);
                          });
                        });
                        let ContactQTNcount = res.data.item.length;
                        if (ContactQTNcount) {
                          ContactQTNcount =
                            ContactQTNcount >= 10
                              ? ContactQTNcount
                              : "0" + ContactQTNcount;
                        }
                        HomeStore().ObjPopupData.ContactQTNcount =
                          ContactQTNcount;
                        HomeStore().ObjPopupData.ContactQTN = res.data;
                        HomeStore().ObjPopupData1 = extend(
                          HomeStore().ObjPopupData,
                          true
                        );
                        HomeStore().ObjPopupData.type = "RFQ";
                        HomeStore().detailLoading = false;
                        HomeStore().showDetail = true;
                        HomeStore().isReply = false;
                      });
                    });
                  }
                }
              } else {
                this.catchEvent();
              }
            });
          }
        });
      }
    },
    //QTN详情
    getQTNDetails() {
      if (this.showDetails) {
        HomeStore().ObjPopupData.create_time = this.ObjPopupData.create_time;
        HomeStore().ObjPopupData.id = this.ObjPopupData.id;
        HomeStore().showDetail = true;
        HomeStore().isDetail = true;
        HomeStore().detailLoading = true;
        HomeStore().switchPopupData.show = false;
        HomeStore().switchPopupData.data = [];
        Rfq.$getInquiryInfo({
          token: HomeStore().token,
          inquiry_id: this.ObjPopupData.data.inquiry_id,
          isPublic: this.ObjPopupData.data.isPublic,
        }).then((inquiry) => {
          if (inquiry.Status == 1) {
            this.catchEvent();
            return;
          }
          Rfq.$Product({
            token: HomeStore().token,
            id: this.ObjPopupData.data.inquiry_id,
            isPublic: this.ObjPopupData.data.isPublic,
          }).then((res) => {
            if (res.Status == 1) {
              this.catchEvent();
              return;
            }
            if (res.data.length == 0) {
              this.catchEvent();
              return;
            }
            res.data.inquiryInfo = inquiry.data.inquiryInfo;
            let List1 = res.data;
            if (this.ObjPopupData.data.slackType == "MyQTN") {
              $axios
                .getMyRfqVendor({
                  token: HomeStore().token,
                  inquiry_id: this.ObjPopupData.data.inquiry_id,
                })
                .then((res) => {
                  if (res.Status != 0) {
                    return;
                  }
                  let RfqVendor = "";
                  let Rfqsales = "";
                  let RfqVendor1 = "";
                  let Rfqsales1 = "";
                  let vendorContactList = [];
                  let vendorInfo = res.data.vendorInfo;
                  vendorInfo.map((item) => {
                    item.vendorContact.map((res) => {
                      vendorContactList.push({
                        RfqVendor: item.vendor,
                        nickname: res.nickname,
                        user_uid: res.user_uid,
                      });
                    });
                  });
                  vendorContactList.map((item) => {
                    if (item.user_uid == HomeStore().setting.dialogueInfo.id) {
                      RfqVendor = item.RfqVendor;
                      Rfqsales = item.nickname;
                    }
                    if (item.user_uid == this.userInfo.user_uid) {
                      RfqVendor1 = item.RfqVendor;
                      Rfqsales1 = item.nickname;
                    }
                  });
                  List1.RfqVendor = RfqVendor;
                  List1.Rfqsales = Rfqsales;
                  List1.RfqVendor1 = RfqVendor1;
                  List1.Rfqsales1 = Rfqsales1;
                  List1.vendorContactList = vendorContactList;
                  HomeStore().ObjPopupData.RFQdata = List1;
                  if (
                    inquiry.data.inquiryInfo.ownerId ==
                      this.userInfo.user_uid ||
                    inquiry.data.inquiryInfo.create_user ==
                      this.userInfo.user_uid
                  ) {
                    Rfq.$orderget_order_purchase({
                      token: HomeStore().token,
                      inquiry_id: this.ObjPopupData.data.inquiry_id,
                      isPublic: 4,
                    }).then((res) => {
                      res.data.item.map((item) => {
                        item.model = item.product.model;
                        item.brand_name = item.brand.brand_name;
                        item.children.map((children) => {
                          children.product = item.product;
                          children.brand = item.brand;
                          children.model = item.product.model;
                          children.Qty = item.Qty;
                          children.brand_name = item.brand.brand_name;
                          res.data.item.push(children);
                        });
                      });
                      let List = res.data;
                      let ContactQTNcount = List.item.length;
                      if (ContactQTNcount > 0) {
                        ContactQTNcount =
                          ContactQTNcount >= 10
                            ? ContactQTNcount
                            : "0" + ContactQTNcount;
                      }
                      HomeStore().ObjPopupData.type = "QTN";
                      HomeStore().ObjPopupData.slackType =
                        this.ObjPopupData.data.slackType;
                      HomeStore().ObjPopupData.ContactQTNcount =
                        ContactQTNcount;
                      HomeStore().ObjPopupData.ContactQTN = List;
                      HomeStore().detailLoading = false;
                      HomeStore().showDetail = true;
                      HomeStore().isReply = false;
                      HomeStore().ObjPopupData1 = extend(
                        HomeStore().ObjPopupData,
                        true
                      );
                    });
                  } else {
                    Rfq.$orderget_order_purchase({
                      token: HomeStore().token,
                      inquiry_id: this.ObjPopupData.data.inquiry_id,
                      isPublic: this.ObjPopupData.data.isPublic,
                    }).then((res) => {
                      res.data.item.map((item) => {
                        item.model = item.product.model;
                        item.brand_name = item.brand.brand_name;
                        item.children.map((children) => {
                          children.product = item.product;
                          children.brand = item.brand;
                          children.model = item.model;
                          children.Qty = item.Qty;
                          children.brand_name = item.brand_name;
                          res.data.item.push(children);
                        });
                      });
                      let PurchaseQTNcount = res.data.item.length;
                      if (PurchaseQTNcount > 0) {
                        PurchaseQTNcount =
                          PurchaseQTNcount >= 10
                            ? PurchaseQTNcount
                            : "0" + PurchaseQTNcount;
                      }
                      HomeStore().ObjPopupData.PurchaseQTNcount =
                        PurchaseQTNcount;
                      HomeStore().ObjPopupData.PurchaseQTN = res.data;
                      Rfq.$orderget_order_purchase({
                        token: HomeStore().token,
                        inquiry_id: this.ObjPopupData.data.inquiry_id,
                        isContact: 1,
                        isPublic: this.ObjPopupData.data.isPublic,
                      }).then((res6) => {
                        res6.data.item.map((item) => {
                          item.model = item.product.model;
                          item.brand_name = item.brand.brand_name;
                          item.children.map((children) => {
                            children.product = item.product;
                            children.brand = item.brand;
                            children.model = item.model;
                            children.Qty = item.Qty;
                            children.brand_name = item.brand_name;
                            res6.data.item.push(children);
                          });
                        });
                        res6.data.supplier_id =
                          this.ObjPopupData.data.supplier_id;
                        HomeStore().ObjPopupData.type = "QTN";
                        HomeStore().ObjPopupData.slackType =
                          this.ObjPopupData.data.slackType;
                        let ContactQTNcount = res6.data.item.length;
                        if (ContactQTNcount) {
                          ContactQTNcount =
                            ContactQTNcount >= 10
                              ? ContactQTNcount
                              : "0" + ContactQTNcount;
                        }
                        HomeStore().ObjPopupData.ContactQTNcount =
                          ContactQTNcount;
                        HomeStore().ObjPopupData.ContactQTN = res6.data;
                        HomeStore().detailLoading = false;
                        HomeStore().showDetail = true;
                        HomeStore().isReply = false;
                        HomeStore().ObjPopupData1 = extend(
                          HomeStore().ObjPopupData,
                          true
                        );
                      });
                    });
                  }
                });
            } else {
              if (this.userInfo.type == 3) {
                HomeStore().ObjPopupData.RFQdata = List1;
                Rfq.$pollingTeam_product({
                  token: HomeStore().token,
                  id: this.ObjPopupData.data.inquiry_id,
                  isPublic: this.ObjPopupData.data.isPublic,
                }).then((q) => {
                  if (List1.data.length == 0) {
                    List1.data.push(...q.data.data);
                  }
                  HomeStore().ObjPopupData.RFQdata = List1;
                  Rfq.$orderget_order_purchase({
                    token: HomeStore().token,
                    inquiry_id: this.ObjPopupData.data.inquiry_id,
                    isPublic: this.ObjPopupData.data.isPublic,
                  }).then((res) => {
                    res.data.item.map((item) => {
                      item.model = item.product.model;
                      item.brand_name = item.brand.brand_name;
                      item.children.map((children) => {
                        children.product = item.product;
                        children.brand = item.brand;
                        children.model = item.product.model;
                        children.Qty = item.Qty;
                        children.brand_name = item.brand.brand_name;
                        res.data.item.push(children);
                      });
                    });
                    let List = res.data;
                    Rfq.$orderGet_team_purchase({
                      token: HomeStore().token,
                      inquiry_id: this.ObjPopupData.data.inquiry_id,
                      isPublic: this.ObjPopupData.data.isPublic,
                    }).then((res1) => {
                      res1.data.item.map((item) => {
                        item.model = item.product.model;
                        item.brand_name = item.brand.brand_name;
                        item.children.map((children) => {
                          children.product = item.product;
                          children.brand = item.brand;
                          children.model = item.product.model;
                          children.Qty = item.Qty;
                          children.brand_name = item.brand.brand_name;
                          res.data.item.push(children);
                        });
                      });
                      List.item.push(...res1.data.item);
                      let PurchaseQTNcount = List.item.length;
                      if (PurchaseQTNcount > 0) {
                        PurchaseQTNcount =
                          PurchaseQTNcount >= 10
                            ? PurchaseQTNcount
                            : "0" + PurchaseQTNcount;
                      }
                      HomeStore().ObjPopupData.PurchaseQTNcount =
                        PurchaseQTNcount;
                      HomeStore().ObjPopupData.PurchaseQTN = List;
                      Rfq.$orderget_order_purchase({
                        token: HomeStore().token,
                        inquiry_id: this.ObjPopupData.data.inquiry_id,
                        isContact: 1,
                        isPublic: this.ObjPopupData.data.isPublic,
                      }).then((res) => {
                        res.data.item.map((item) => {
                          item.model = item.product.model;
                          item.brand_name = item.brand.brand_name;
                          item.children.map((children) => {
                            children.product = item.product;
                            children.brand = item.brand;
                            children.model = item.product.model;
                            children.Qty = item.Qty;
                            children.brand_name = item.brand.brand_name;
                            res.data.item.push(children);
                          });
                        });
                        res.data.supplier_id =
                          this.ObjPopupData.data.supplier_id;
                        HomeStore().ObjPopupData.type = "QTN";
                        HomeStore().ObjPopupData.slackType =
                          this.ObjPopupData.data.slackType;
                        let ContactQTNcount = res.data.item.length;
                        if (ContactQTNcount) {
                          ContactQTNcount =
                            ContactQTNcount >= 10
                              ? ContactQTNcount
                              : "0" + ContactQTNcount;
                        }
                        HomeStore().ObjPopupData.ContactQTNcount =
                          ContactQTNcount;
                        HomeStore().ObjPopupData.ContactQTN = res.data;
                        HomeStore().detailLoading = false;
                        HomeStore().showDetail = true;
                        HomeStore().isReply = false;
                        HomeStore().ObjPopupData1 = extend(
                          HomeStore().ObjPopupData,
                          true
                        );
                      });
                    });
                  });
                });
              } else {
                HomeStore().ObjPopupData.RFQdata = List1;
                Rfq.$orderget_order_purchase({
                  token: HomeStore().token,
                  inquiry_id: this.ObjPopupData.data.inquiry_id,
                  isPublic: this.ObjPopupData.data.isPublic,
                }).then((res) => {
                  res.data.item.map((item) => {
                    item.model = item.product.model;
                    item.brand_name = item.brand.brand_name;
                    item.children.map((children) => {
                      children.product = item.product;
                      children.brand = item.brand;
                      children.model = item.model;
                      children.Qty = item.Qty;
                      children.brand_name = item.brand_name;
                      res.data.item.push(children);
                    });
                  });
                  let PurchaseQTNcount = res.data.item.length;
                  if (PurchaseQTNcount > 0) {
                    PurchaseQTNcount =
                      PurchaseQTNcount >= 10
                        ? PurchaseQTNcount
                        : "0" + PurchaseQTNcount;
                  }
                  HomeStore().ObjPopupData.PurchaseQTNcount = PurchaseQTNcount;
                  HomeStore().ObjPopupData.PurchaseQTN = res.data;
                  Rfq.$orderget_order_purchase({
                    token: HomeStore().token,
                    inquiry_id: this.ObjPopupData.data.inquiry_id,
                    isContact: 1,
                    isPublic: this.ObjPopupData.data.isPublic,
                  }).then((res6) => {
                    res6.data.item.map((item) => {
                      item.model = item.product.model;
                      item.brand_name = item.brand.brand_name;
                      item.children.map((children) => {
                        children.product = item.product;
                        children.brand = item.brand;
                        children.model = item.model;
                        children.Qty = item.Qty;
                        children.brand_name = item.brand_name;
                        res6.data.item.push(children);
                      });
                    });
                    res6.data.supplier_id = this.ObjPopupData.data.supplier_id;
                    HomeStore().ObjPopupData.type = "QTN";
                    HomeStore().ObjPopupData.slackType =
                      this.ObjPopupData.data.slackType;
                    let ContactQTNcount = res6.data.item.length;
                    if (ContactQTNcount) {
                      ContactQTNcount =
                        ContactQTNcount >= 10
                          ? ContactQTNcount
                          : "0" + ContactQTNcount;
                    }
                    HomeStore().ObjPopupData.ContactQTNcount = ContactQTNcount;
                    HomeStore().ObjPopupData.ContactQTN = res6.data;
                    HomeStore().detailLoading = false;
                    HomeStore().showDetail = true;
                    HomeStore().isReply = false;
                    HomeStore().ObjPopupData1 = extend(
                      HomeStore().ObjPopupData,
                      true
                    );
                  });
                });
              }
            }
          });
        });
      }
    },
    //销售订单详情
    getSaleOrderDetails() {
      if (this.showDetails) {
        HomeStore().ObjPopupData.create_time = this.ObjPopupData.create_time;
        HomeStore().ObjPopupData.id = this.ObjPopupData.id;
        HomeStore().showDetail = true;
        HomeStore().isDetail = true;
        HomeStore().detailLoading = true;
        HomeStore().switchPopupData.show = false;
        HomeStore().switchPopupData.data = [];
        Order.orderDetail({
          token: HomeStore().token,
          order_id: this.SaleOrderData.data.customer.order_id,
          page: 1,
          pageSize: 10,
          is_cost: 1,
          is_shipping: 1,
          msg: 1,
          msg_id: this.SaleOrderData.id,
          // state: 0,
        }).then((res) => {
          if (res.Status != 0) {
            // this.catchEvent();
            return;
          }
          if (res.data.length == 0) {
            this.catchEvent();
            return;
          }
          let status = [];
          let List = [];
          let dataList = [];
          let SubTotal = 0;
          let GrandTotal = 0;
          let customer = res.data.customer;
          res.data.list.data.map((item) => {
            item.status.map((state) => {
              item.statusList = [];
              if (status.indexOf(state.state) == -1) {
                status.push(state.state);
              }
              item.statusList.push(state.state);
              List.push({
                Brand_name: item.Brand_name,
                leadingtime: item.leadingtime,
                product_condition: item.product_condition,
                product_name_pi: item.product_name_pi,
                Qty: state.total,
                state_text: state.state_text,
                state: state.state,
                cost: item.cost,
                price: item.price,
              });
            });
            SubTotal += item.price * item.quantity;
          });
          status.map((item, index) => {
            dataList[index] = List.filter((i) => i.state == item);
          });
          GrandTotal =
            SubTotal -
            Number(customer.discount_value) +
            Number(customer.Payment_charge) +
            Number(customer.Shipping_cost) +
            Number(customer.Invoice_shipping_cost);

          res.data.dataList = res.data.list.data;
          res.data.dataList1 = extend(res.data.list.data, true);
          res.data.SubTotal = Number(SubTotal).toFixed(2);
          res.data.GrandTotal = Number(GrandTotal).toFixed(2);
          res.data.order_id = this.SaleOrderData.data.customer.order_id;
          res.data.statusList = status;
          res.data.payment = res.data.payment || {};
          if (res.data.payment.config_value) {
            res.data.payment.config_value = res.data.payment.config_value
              .replace(",\r\n", "")
              .replace(/\n/g, "<br>");
          } else {
            if (res.data.payment.bank_name) {
              res.data.payment.config_value =
                res.data.payment.bank_name +
                `(${res.data.payment.currency})` +
                res.data.payment.account;
              res.data.payment.config_name = res.data.payment.bank_name;
            } else {
              res.data.payment.config_value = "-";
              res.data.payment.config_name = "-";
            }
            // res.data.payment.config_short = res.data.payment.bank_name;
          }
          let Contactsaddress = res.data.customer.address || "-";
          let companyAddress = res.data.company;
          if (useDemoStore().lang == "zh-cn") {
            Contactsaddress.address =
              Contactsaddress.name +
              "," +
              Contactsaddress.city +
              "," +
              Contactsaddress.address;
            companyAddress.address =
              companyAddress.name +
              "," +
              companyAddress.city +
              "," +
              companyAddress.address;
          } else {
            Contactsaddress.address =
              Contactsaddress.name +
              Contactsaddress.address +
              "," +
              Contactsaddress.city +
              "," +
              Contactsaddress.country;
            companyAddress.address =
              companyAddress.address +
              "," +
              companyAddress.city +
              "," +
              companyAddress.name;
          }

          res.data.PurchaseOrderNum = this.SaleOrderData.data.PurchaseOrderNum;
          res.data.PurchaseOrderteskNum =
            this.SaleOrderData.data.PurchaseOrderteskNum;
          // res.data.Purchaseordertesk_detailed_id = this.SaleOrderData.data.Purchaseordertesk_detailed_id;
          res.data.PI_name = this.SaleOrderData.data.customer.PI_name;
          res.data.purchaseorderData =
            this.SaleOrderData.data.purchaseorderData;
          if (useDemoStore().lang == "zh-cn") {
            res.data.CustomerName6 =
              Kernaldec(res.data.customer.lastname) +
              Kernaldec(res.data.customer.firstname);
          } else {
            res.data.CustomerName6 =
              Kernaldec(res.data.customer.firstname) +
              Kernaldec(res.data.customer.lastname);
          }
          HomeStore().ObjPopupData.SaleOrderData = res.data;
          HomeStore().ObjPopupData.type = "SaleOrder";
          HomeStore().detailLoading = false;
          HomeStore().showDetail = true;
          HomeStore().isReply = false;
          if (this.userInfo.type != 4) {
            this.getPurchaseOrdersList();
          }
        });
      }
    },
    //获取采购订单的数据
    getPurchaseOrdersList() {
      Order.purchaseOrderTakeList({
        token: HomeStore().token,
        PI_name: HomeStore().ObjPopupData.SaleOrderData.PI_name,
        page: 1,
        pageSize: 10,
        is_team: 1,
        // purchaser_id: HomeStore().userInfo.user_uid
      }).then((res) => {
        let purchase_tesk_ids = [];
        if (res.data.total) {
          res.data.data.map((item) => {
            purchase_tesk_ids.push({
              purchaseordertesk_id: item.purchaseordertesk_id,
            });
          });
          Order.purchaseOrderteskDetail({
            token: HomeStore().token,
            page: 1,
            pageSize: 20,
            purchase_tesk_ids,
          }).then((res2) => {
            if (res2.data.length == 0) {
              return;
            }
            let Purchaseordertesk_detailed_id = [];
            res2.data.list.data.map((item) => {
              Purchaseordertesk_detailed_id.push(
                item.Purchaseordertesk_detailed_id
              );
            });
            Order.purchaseOrderList({
              token: HomeStore().token,
              page: 1,
              pageSize: 10,
              is_team: 1,
              Purchaseordertesk_detailed_id,
            }).then((res) => {
              if (res.Status == 1) {
                return;
              }
              HomeStore().ObjPopupData.SaleOrderData.purchaseorderData =
                res.data;
            });
          });
        }
      });
    },
    //采购订单详情
    getpurseOrderDetails() {
      if (this.showDetails) {
        let user_type = this.purchaseOrderData.data.user_type || -1;
        HomeStore().ObjPopupData.create_time = this.ObjPopupData.create_time;
        HomeStore().ObjPopupData.id = this.ObjPopupData.id;
        HomeStore().showDetail = true;
        HomeStore().isDetail = true;
        HomeStore().detailLoading = true;
        HomeStore().switchPopupData.show = false;
        HomeStore().switchPopupData.data = [];
        // if (!this.purchaseOrderData.data.supplier_company_id) {
        //   Order.purchaseOrderList({
        //     token: HomeStore().token,
        //     page: 1,
        //     pageSize: 10,
        //     Purchaseordername
        //   });
        // }
        if (user_type == 4) {
          Order.cpoItem({
            token: HomeStore().token,
            page: 1,
            pageSize: 10,
            customer_order_id: this.purchaseOrderData.data.purchaseorder_id,
            msg: 1,
          }).then((res) => {
            if (res.Status != 0) {
              return;
            }
            if (res.data.length == 0) {
              this.catchEvent();
              return;
            }
            let ordersData = res.data.orders;
            res.data.purchaseorder_id =
              this.purchaseOrderData.data.purchaseorder_id;
            res.data.create_time = this.purchaseOrderData.data.create_time;
            res.data.create_name = ordersData.creator;
            if (ordersData.customer) {
              if (useDemoStore().lang == "zh-cn") {
                res.data.Contacts =
                  Kernaldec(ordersData.customer.lastname) +
                  Kernaldec(ordersData.customer.firstname);
              } else {
                res.data.Contacts =
                  Kernaldec(ordersData.customer.firstname) +
                  Kernaldec(ordersData.customer.lastname);
              }
            }
            if (ordersData.supplier_contanct) {
              if (useDemoStore().lang == "zh-cn") {
                res.data.sale =
                  Kernaldec(ordersData.supplier_contanct.lastname) +
                  Kernaldec(ordersData.supplier_contanct.firstname);
              } else {
                res.data.sale =
                  Kernaldec(ordersData.supplier_contanct.firstname) +
                  Kernaldec(ordersData.supplier_contanct.lastname);
              }
            }
            if (ordersData.supplier) {
              res.data.CompanyName = Kernaldec(ordersData.supplier.CompanyName);
            }
            res.data.PurchaseOrderteskNum =
              this.purchaseOrderData.data.PurchaseOrderteskNum;
            res.data.PI_name = this.purchaseOrderData.data.PI_name;
            res.data.Purchaseordername =
              this.purchaseOrderData.data.Purchaseordername;
            res.data.supplier_id = this.purchaseOrderData.data.supplier_id;
            res.data.supplier_company_id =
              this.purchaseOrderData.data.supplier_company_id;

            res.data.user_type = user_type;
            res.data.items.data.map((item) => {
              item.Model = item.model;
              item.dty = item.quantity;
              item.Brand_name = item.brand;
              item.product_condition = item.condition;
              item.Leading_name = item.leadingtime;
              item.cost = item.price;
              item.purchase_current = res.data.orders.current
              item.sale_current = res.data.orders.current
            });
            res.data.data = res.data.items.data;
            res.data.total = res.data.items.data.length;
            HomeStore().ObjPopupData.PurchaseOrderData = extend(res.data, true);
            HomeStore().ObjPopupData.type = "PurchaseOrder";
            HomeStore().detailLoading = false;
            HomeStore().showDetail = true;
            HomeStore().isReply = false;
          });
        } else {
          Order.purchaseOrderDetailed({
            token: HomeStore().token,
            page: 1,
            pageSize: 20,
            Purchaseorder_id: this.purchaseOrderData.data.purchaseorder_id,
            msg: 1,
          }).then((res) => {
            if (res.Status != 0) {
              // this.catchEvent();
              return;
            }
            if (res.data.length == 0) {
              this.catchEvent();
              return;
            }
            res.data.purchaseorder_id =
              this.purchaseOrderData.data.purchaseorder_id;
            res.data.sale = this.purchaseOrderData.data.sale;
            res.data.create_name = this.purchaseOrderData.data.create_name;
            res.data.create_user = this.purchaseOrderData.data.create_user;
            res.data.create_time = this.purchaseOrderData.data.create_time;
            res.data.Contacts = this.purchaseOrderData.data.Contacts;
            res.data.PurchaseOrderteskNum =
              this.purchaseOrderData.data.PurchaseOrderteskNum;
            res.data.PI_name = this.purchaseOrderData.data.PI_name;
            res.data.Purchaseordername =
              this.purchaseOrderData.data.Purchaseordername;
            res.data.supplier_id = this.purchaseOrderData.data.supplier_id;
            res.data.supplier_company_id =
              this.purchaseOrderData.data.supplier_company_id;
            res.data.user_type = user_type;
            res.data.data = res.data.list.data;
            res.data.total = res.data.list.data.length;
            HomeStore().ObjPopupData.PurchaseOrderData = res.data;
            HomeStore().ObjPopupData.type = "PurchaseOrder";
            HomeStore().detailLoading = false;
            HomeStore().showDetail = true;
            HomeStore().isReply = false;
          });
        }
      }
    },
    //错误处理
    catchEvent() {
      if (useDemoStore().lang == "zh-cn") {
        ElMessage({
          type: "info",
          message: "没有数据",
        });
      } else {
        ElMessage({
          type: "info",
          message: "No Data",
        });
      }
      HomeStore().detailLoading = false;
      HomeStore().isDetail = false;
      HomeStore().showDetail = false;
    },
    closeClick() {
      this.$emit("closeClick");
    },
  },
};
</script>
<style lang="less">
.ObjPopup_Body {
  display: flex;
  width: 100%;
  cursor: pointer;
  .CurrentBox {
    width: 100%;
    .infoText {
      color: #333;
      font-weight: 700;
    }
    .container {
      border: solid 1px #e4e4e4;
      border-radius: 4px;
      padding: 0 0 0 15px;
      .content {
        width: calc(100% - 34px);
        height: 100%;
        padding: 12px 15px;
        .title {
          color: #333;
          font-size: 16px;
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 3px;
          text-align: left;
          max-height: 66px;
          span {
            margin-right: 5px;
          }
        }
        .info {
          color: #555555;
          font-size: 12px;
          margin-bottom: 4px;
          text-align: left;
        }
        .info:last-child {
          margin-bottom: 0;
        }
      }
      .sendWrap {
        background: #cad2d9;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 46px;
        cursor: pointer;
        button {
          background: none;
          border: none;
          width: 46px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .sendWrap:hover {
        background: #3370ff;
      }
    }
  }
  .QTNBox {
    .QTNTopInfo {
      color: #555555;
      border-bottom: dashed 1px #d7e2ed;
      padding: 10px 0;
    }
    .info {
      p {
        margin-bottom: 3px;
        font-size: 15px;
        color: #333;
      }
    }
  }
  .ISpadding {
    padding: 20px 20px 33px 20px;
    .container {
      margin-top: 20px;
    }
  }
  .selectBox {
    border-left: solid 1px #e4e4e4;
    width: 200px;
    padding: 40px 20px 0 20px;
    position: relative;
    .el-icon {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    div {
      justify-content: space-between;
      margin-bottom: 22px;
      cursor: pointer;
      p {
        font-size: 16px;
      }
    }
  }
}
</style>
